import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PopularPort = ({
  isLast, popularPortClass, locationAbbr, locationName, locationCountry, onClickPopularPort
}) => {
  const wrapperClass = classnames(
    'grid no-gutter justify-content-between popolar-port-overlay py-1 rounded cursor-pointer',
    popularPortClass,
    {'mb-2': !isLast}
  );

  return (
    <div className={wrapperClass} onClick={() => onClickPopularPort(locationAbbr, locationName)}>
      <div className="grid-item text-truncate">{locationName}</div>
      <div className="grid-item-auto text-muted text-right">{locationCountry}</div>
    </div>
  );
};

PopularPort.propTypes = {
  isLast: PropTypes.bool.isRequired,
  popularPortClass: PropTypes.string,
  locationAbbr: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  locationCountry: PropTypes.string.isRequired,
  onClickPopularPort: PropTypes.func.isRequired
};

export default PopularPort;
